import axios from 'axios';
import { renewToken, signinRedirect } from '../apis/auth.api';
import { getHttpStatusCodeName, HttpStatusCode } from '../constants';
import { getAccessTokenFromLS, clearLS } from './auth'; // <-- dùng hàm clearLS đã cải tiến
import { showNotification } from './notification';
// Hàm xử lý đệ quy tất cả các trường có kiểu Date trong đối tượng
// const processDates = (obj: any) => {
//   // Kiểm tra nếu đối tượng tồn tại và là một object
//   if (obj && typeof obj === "object") {
//     // Duyệt qua tất cả các thuộc tính của đối tượng
//     Object.keys(obj).forEach((key) => {
//       // Nếu thuộc tính là một đối tượng Date
//       if (obj[key] instanceof Date) {
//         // Lấy offset múi giờ của người dùng (tính bằng mili giây)
//         const userTimezoneOffset = obj[key].getTimezoneOffset() * 60000;
//         // Tạo một ngày mới không có offset múi giờ
//         const dateWithoutOffset = new Date(
//           obj[key].getTime() - userTimezoneOffset
//         );
//         // Gán lại giá trị ngày không có offset cho thuộc tính
//         obj[key] = dateWithoutOffset;
//       }
//       // Nếu thuộc tính là một mảng
//       else if (Array.isArray(obj[key])) {
//         // Duyệt qua từng phần tử trong mảng và xử lý đệ quy
//         obj[key].forEach((item: any) => processDates(item));
//       }
//       // Nếu thuộc tính là một đối tượng (không phải Date và không phải mảng)
//       else if (obj[key] && typeof obj[key] === "object") {
//         // Xử lý đệ quy đối tượng con
//         processDates(obj[key]);
//       }
//     });
//   }
//   // Trả về đối tượng đã được xử lý
//   return obj;
// };
class Http {
    instance;
    // Cờ chống đua
    static refreshing = null;
    static redirecting = false;
    constructor(version = 'v1') {
        const baseURL = process.env.NODE_ENV === 'production'
            ? `${process.env.REACT_APP_API_ENDPOINT_PROD}/${version}`
            : `${process.env.REACT_APP_API_ENDPOINT}/${version}`;
        this.instance = axios.create({
            baseURL,
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json'
            }
            // transformRequest: [
            //   (data, headers) => {
            //     if (data instanceof FormData) {
            //       return data;
            //     }
            //     return JSON.stringify(processDates(data));
            //   },
            // ],
        });
        // Request: luôn lấy access_token mới nhất từ localStorage
        this.instance.interceptors.request.use((config) => {
            const accessToken = getAccessTokenFromLS();
            if (accessToken && config.headers) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            return config;
        }, (error) => Promise.reject(error));
        // Response: clear sạch session khi gặp 401 và redirect login
        this.instance.interceptors.response.use((response) => response, async (error) => {
            const { response, config } = error;
            const original = config;
            // 401 → thử silent renew + retry 1 lần
            if (response?.status === HttpStatusCode.Unauthorized) {
                try {
                    if (!Http.refreshing) {
                        Http.refreshing = renewToken()
                            .then((u) => u?.access_token ?? null)
                            .catch(() => null)
                            .finally(() => {
                            Http.refreshing = null;
                        });
                    }
                    const newToken = await Http.refreshing;
                    if (newToken) {
                        // gắn token mới rồi retry
                        original.headers = original.headers ?? {};
                        original.headers.Authorization = `Bearer ${newToken}`;
                        return this.instance.request(original);
                    }
                }
                catch { }
                // Renew thất bại → redirect 1 lần duy nhất
                if (!Http.redirecting && !window.location.pathname.includes('/signin-oidc')) {
                    Http.redirecting = true;
                    // lưu đường dẫn để quay lại sau login
                    localStorage.setItem('returnUrl', window.location.pathname + window.location.search);
                    clearLS(); // chỉ xoá key app
                    await signinRedirect();
                }
            }
            else {
                if (response && response.data instanceof Blob) {
                    const text = await response.data.text();
                    showNotification(text, 'error');
                }
                else if (response?.status) {
                    const errMessage = response.data || getHttpStatusCodeName(response.status);
                    showNotification(`${errMessage}`, 'error');
                }
            }
            return Promise.reject(error);
        });
    }
}
const http = new Http().instance;
const httpV2 = new Http('v2').instance;
export { http, httpV2 };
